export const LOADER_VARIANTS = {
  INLINE: 'inline',
  INDETERMINATE: 'indeterminate',
  DETERMINATE: 'determinate',
};

export const LOADER_LABEL_VARIANTS = {
  INDETERMINATE: 'indeterminate',
  DETERMINATE: 'determinate',
};

export const LOADER_SIZE = {
  LARGE: 'large',
  SMALL: 'small',
};

export const PROGRESS_CIRCLE_SIZE = {
  SMALL: 'small',
  LARGE: 'large',
  EXTRA_LARGE: 'extra-large',
  XXL: 'xxl',
};
